import { LocaleDateFormat } from 'core/enums/LocaleDateFormat';

// Moment.js format tokens (DD for day, YYYY for year)
export const localeMapMoment: {
  [key in LocaleDateFormat]: { dateFormat: string; mask: string; dateAndTimeFormat: string };
} = {
  [LocaleDateFormat.DE]: {
    dateFormat: 'DD.MM.YYYY',
    dateAndTimeFormat: 'DD.MM.YYYY - HH:mm:ss',
    mask: '__.__.____',
  },
  [LocaleDateFormat.EN]: {
    dateFormat: 'DD/MM/YYYY',
    dateAndTimeFormat: 'DD/MM/YYYY - HH:mm:ss',
    mask: '__/__/____',
  },
  [LocaleDateFormat.US]: {
    dateFormat: 'MM/DD/YYYY',
    dateAndTimeFormat: 'MM/DD/YYYY - hh:mm:ss a',
    mask: '__/__/____',
  },
};

// date-fns format tokens (dd for day, yyyy for year)
export const localeMap: { [key in LocaleDateFormat]: { dateFormat: string; mask: string; dateAndTimeFormat: string } } =
  {
    [LocaleDateFormat.DE]: {
      dateFormat: 'dd.MM.yyyy',
      dateAndTimeFormat: 'dd.MM.yyyy - HH:mm:ss',
      mask: '__.__.____',
    },
    [LocaleDateFormat.EN]: {
      dateFormat: 'dd/MM/yyyy',
      dateAndTimeFormat: 'dd/MM/yyyy - HH:mm:ss',
      mask: '__/__/____',
    },
    [LocaleDateFormat.US]: {
      dateFormat: 'MM/dd/yyyy',
      dateAndTimeFormat: 'MM/dd/yyyy - hh:mm:ss a',
      mask: '__/__/____',
    },
  };

// Use for date-fns based components (MBSDatePicker, etc.)
export const getFormat = (locale: LocaleDateFormat) => localeMap[locale].dateFormat;

// Use for moment.js based components (AdapterMoment)
export const getMomentFormat = (locale: LocaleDateFormat) => localeMapMoment[locale].dateFormat;

export const getMask = (locale: LocaleDateFormat) => localeMap[locale].mask;
